import { render } from "./ClientManagementDashboard.vue?vue&type=template&id=0e4c4268&scoped=true"
import script from "./ClientManagementDashboard.vue?vue&type=script&lang=js"
export * from "./ClientManagementDashboard.vue?vue&type=script&lang=js"

import "./ClientManagementDashboard.vue?vue&type=style&index=0&id=0e4c4268&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e4c4268"]])

export default __exports__